import type { FormSchema, Schema } from '@cli-types/core-engine/schema.js'

export function collectCustomComponents(schema: Schema | FormSchema): string[] {
  if (schema.type === 'form') {
    return []
  }

  return (schema.columns || [])
    .filter((column) => column.type === 'custom' && column.component)
    .map((column) => column.component as string)
    .sort()
}
